export function MenuHeader({ tenant, menu, appearance }) {
  const { branding } = appearance;
  const showDescription = branding.showDescription && (menu.description || tenant.description);
  const hasCover = Boolean(branding.coverImageUrl);

  return (
    <header className={`rm-header${hasCover ? ' rm-header--with-cover' : ''}`}>
      {hasCover && (
        <div className="rm-header__cover-wrap">
          <img
            className="rm-header__cover"
            src={branding.coverImageUrl}
            alt=""
            role="presentation"
            onError={(event) => {
              event.currentTarget.hidden = true;
            }}
          />
          {/* Scrim, not a flat overlay color, so the photo still reads
              through while guaranteeing the overlaid text stays legible
              regardless of how bright the photo is. */}
          <div className="rm-header__scrim" aria-hidden="true" />
        </div>
      )}
      <div className="rm-header__body">
        {branding.showLogo && branding.logoUrl && (
          <img
            className="rm-header__logo"
            src={branding.logoUrl}
            alt={`${tenant.name} logo`}
            onError={(event) => {
              event.currentTarget.hidden = true;
            }}
          />
        )}
        {branding.showName && <h1 className="rm-header__name">{tenant.name}</h1>}
        {showDescription && <p className="rm-header__description">{menu.description || tenant.description}</p>}
      </div>
    </header>
  );
}
